module.exports = __webpack_public_path__ + "img/comptia.1b266cc0.png";